import {
  HabitSchedule,
  ScheduleAction,
  ScheduleCompletionActions,
  Timestamp,
} from '@griply/types';

import { getActiveSchedule } from './get-active-schedule';

export const applyLogCompletionValue = (
  schedules: HabitSchedule[] | undefined | null,
  enterValue: boolean,
  today: Timestamp,
): HabitSchedule[] | null => {
  const activeSchedule = getActiveSchedule(schedules, today);
  if (!schedules?.length || !activeSchedule) {
    return null;
  }

  const hasAction =
    activeSchedule.action?.type ===
    ScheduleCompletionActions.LogCompletionValue;
  if (hasAction === enterValue) {
    return null;
  }

  const action: ScheduleAction | null = enterValue
    ? { type: ScheduleCompletionActions.LogCompletionValue }
    : null;

  return schedules.map((schedule) =>
    schedule === activeSchedule ? { ...schedule, action } : schedule,
  );
};
